import { DataLandingContext } from 'context/DataLanding.context'
import React from 'react'

export const useDataLanding = () => {
  const context = React.useContext(DataLandingContext)

  if (context === undefined) {
    throw new Error('Error')
  }

  return context
}
